export var CustomerMetadata;
(function (CustomerMetadata) {
    CustomerMetadata["OrgID"] = "orgID";
    CustomerMetadata["Stage"] = "stage";
    CustomerMetadata["AwsAccountID"] = "awsAccountID";
    CustomerMetadata["ItemCode"] = "ItemCode";
})(CustomerMetadata || (CustomerMetadata = {}));
//# sourceMappingURL=customerMetadata.js.map